import { preguntasData } from './mock/preguntas.mock.js';

angular.module('Toke').factory('preguntasRepository', function ($q) {

    function getPreguntas() {
        return $q.resolve(preguntasData);
    }

    // futura conexión API
    // function getPreguntasFromList() {
    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Preguntas')/items";
    // }

    return {
        getPreguntas
    };

});
